import { dateFine } from "../../../util/Utilities";
import ActionComponent from "../../ActionComponent";
import ActionDropdown from "../../ActionDropdown";
import DateFormatter from "../../DateFormatter";
import TableCheck from "../TableCheck";

const ActivityLogColumns = [
    {
        Label: TableCheck,
        Component: TableCheck

    },
    {
        Label: () => 'id',
        accessor: 'id'
    },
    {
        Label: () => 'Usuario',
        Component: ({ value }) => <div className="d-flex align-items-center gap-2 w-100">
            <img src={`${value?.user?.imagePath}`} alt={`${value?.user?.name}`} style={{ height: 40, width: 40 }} />
            <p className="mb-0">
                {value?.user?.name}
            </p>
        </div>
    },
    {
        Label: () => 'Acción',
        Component: ActionComponent
    },
    {
        Label: () => 'Descripción',
        Component: ({ value }) => `${value?.description || '--'}`
    },
    {
        Label: () => 'Fecha de Creación',
        Component: ({ value }) => <DateFormatter value={dateFine(value?.created_at)} dateFormat="dd/MM/yyyy hh:mm:ss" />
    }
];

export default ActivityLogColumns;

